module.exports = __webpack_public_path__ + "img/nevi_hero_desktop_EA_Baker_Gen4144.9575191b.png";